import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Spending hours every week planning lessons from scratch', 'Running out of activities and repeating the same exercises', 'Not knowing how to structure a full year of skill progression', 'Struggling to keep students engaged and motivated during class', 'Having no system to evaluate development and report progress', 'Feeling unprepared before walking into the gym', 'Arriving at class without a clear plan in place', 'Constantly searching online for fresh new games and drills'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-179" data-mp="3jgbuax12vmlp">
      <div className="mx-auto max-w-4xl text-center" data-id="element-180" data-mp="3jdzaeebrf260">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-181" data-mp="3ei0i4fnb900b">
          The teaching reality
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-182" data-mp="1p2avgc5j2zlm">
          If you teach PE, you are probably dealing with at least one of these
          problems.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-183" data-mp="jbadeyq439eo">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-184" data-mp="sdthfm5mvs2i">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-185" data-mp="x5ju3ys1mrx3" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-186" data-mp="1244k75dkzv7t">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-187" data-mp="174sjsffvlkdn">
          How many more classes do you want to keep improvising?
        </p>
      </div>
    </section>;
}